import { updatePartner360Configuration } from 'legacy/lut/services/partner360/configuration/updatePartner360Configuration'
import { map621ToShareOfBusiness } from 'legacy/lut/services/partner360/shareOfBusiness/mappings/map621ToShareOfBusiness'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { selectFinancialYear } from '../../configuration'
import { selectPartner360Data } from '../../configuration'
import { REQUEST_PARTNER360_UPDATE_PARTNER_BASE_METRICS } from '../constants'
import { IShareOfBusiness } from '../models'
import { IPartnerBaseMetricsForm } from '../models'

export const requestUpdatePartnerBaseMetrics = createAsyncThunk<
  IShareOfBusiness,
  IPartnerBaseMetricsForm
>(REQUEST_PARTNER360_UPDATE_PARTNER_BASE_METRICS, async (form, { getState }) => {
  const state = getState() as any
  const configuration = selectPartner360Data(state)
  const fYear = selectFinancialYear(state)

  const updatedData = await updatePartner360Configuration({
    EntryId: configuration.entryId,
    PartnerId: configuration.partnerId,
    FYear: fYear,

    ContractualCustomerCountHP: form.contractualCustomerCountHP,
    ContractualCustomerCountAllBrands: form.contractualCustomerCountAllBrands,
    LastFYRevenuesHP: form.lastFinancialYearRevenuesHP,
    LastFYRevenuesAllBrands: form.lastFinancialYearRevenuesAllBrands,
    MonthlyInvoicedPagesHP: form.monthlyInvoicedPagesHP,
    MonthlyInvoicedPagesAllBrands: form.monthlyInvoicedPagesAllBrands,
  })

  return map621ToShareOfBusiness(updatedData)
})
